import AppEvents from 'Shared/app-events';
import CartApi from './cart-api';
import ds from 'Shared/ds';
import modal from 'Shared/modal';

export default class BookmarkApi {

    static #created = (result) => {
        if (result.Success) {
            AppEvents.emit(this.Events.BOOKMARKLIST_CREATED, result);
        }
    }

    static onChanged = handler => AppEvents.on(this.Events.BOOKMARKLIST_CHANGED, handler);

    static #changed = (result) => {
        if (result.Success) {
            AppEvents.emit(this.Events.BOOKMARKLIST_CHANGED, result);
        }
    }

    static changed = () => AppEvents.emit(this.Events.BOOKMARKLIST_CHANGED);

    static #deleted = (result) => {
        if (result.Success) {
            AppEvents.emit(this.Events.BOOKMARKLIST_DELETED, result);
        }
    }

    static data = id => ds.get(BookmarkApi.#const.DATA, { Id: id });

    static create = (data) => ds
        .post(this.#const.CREATE, data)
        .done(this.#created);

    static select = (id) => ds
        .post(this.#const.SELECT, { Id: id })
        .done(this.#changed);

    static delete = (id) => ds
        .post(this.#const.DELETE, { id: id })
        .done(this.#deleted);

    static addItem = async (variantId) => await ds
            .post(this.#const.ITEM_ADD, {
                productId: variantId
            })
            .done(this.#changed);

    static moveItem = (id, oldIndex, newIndex) => ds
        .post(this.#const.ITEM_MOVE, { Id: id, OldIndex: oldIndex, NewIndex: newIndex })
        .done(this.#changed);

    static updateItemNote = (itemId, note) => ds
        .post(this.#const.ITEM_UPDATE_NOTE, {
            itemId,
            note
        })
        .done(this.#changed);

    static updateItemUnit = (itemId, productUnitId) => ds
        .post(this.#const.ITEM_UPDATE_UNIT, {
            itemId,
            productUnitId
        })
        .done(this.#changed);

    static updateItemQuantity = (itemId, quantity) => ds
        .post(this.#const.ITEM_UPDATE_QUANTITY, {
            itemId,
            quantity
        })
        .done(this.#changed);

    static addItems = (items) => ds
        .post(this.#const.ADD_PRODUCTS, {
            Items: items
        })
        .done(this.#changed);

    static removeItem = (itemId) => ds
        .post(this.#const.ITEM_REMOVE, {
            Items: [itemId]
        })
        .done(this.#changed);

    static addToCart = async (itemId, quantity) => {
        var result = await ds.post(this.#const.ADD_TO_CART, {
                ItemId: itemId,
                Quantity: quantity
            })
            .done(CartApi.changed);

        return result;
    }

    static #const = {
        DATA: "/bookmark/data",
        CREATE: "/bookmark/create",
        DELETE: "/bookmark/delete",
        COPY: "/bookmark/copy",
        SELECT: "/bookmark/select",
        ITEM_ADD: "/bookmark/additem",
        ITEM_MOVE: "/bookmark/moveitem",
        ITEM_UPDATE_NOTE: "/bookmark/updateitem/update/note",
        ITEM_UPDATE_UNIT: "/bookmark/updateitem/unit",
        ITEM_UPDATE_QUANTITY: "/bookmark/updateitem/quantity",
        ITEM_REMOVE: "/bookmark/removeitem",
        ADD_ITEMS: "/bookmark/additems",
        ADD_TO_CART: "/bookmark/addtocart"
    };

    static Events = {
        ADD: "bookmark.add",
        BOOKMARKLIST_CREATED: "bookmarklist-created",
        BOOKMARKLIST_CHANGED: "bookmarklist-changed",
        BOOKMARKLIST_DELETED: "bookmarklist-deleted",
        BOOKMARKLIST_EDIT: "bookmarklist-edit",
        BOOKMARKLIST_SELECT: "bookmarklist-select"
    };
}